import React from 'react'
import Layout from '../Layout'
import DashboardLayout from '../DashboardLayout'
import Reports from '../../../utils/CommonFunctionality/Reports'

const ReportsManagement = (props) => {
    return (
        <Layout props={props}>
            <DashboardLayout title="Report Management">
                <Reports remove_sold={1} remove_unpaid={1} />
            </DashboardLayout>
        </Layout>
    )
}

export default ReportsManagement
